import type { FeatureManifest } from '@/platform/navigation/featureManifest'

export const ordersManifest: FeatureManifest = {
  id: 'orders-orders',
  path: 'orders/orders/:orderId?',
  navPath: '/orders/orders',
  label: 'Đơn hàng',
  requiredPermissions: ['orders'],
  navigationGroup: { id: 'orders', label: 'Quản lý đơn hàng' },
  load: () => import('./entry'),
}
